/* eslint-disable @typescript-eslint/no-unused-vars */
import { HighlightOffOutlined } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import { getMiniProgressBarWidth } from "components/PoisBountyWidgetV3/lib/ProgressSteps/lib/Step/helper";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useLinks } from "hooks/useLinks";
import { PBV3CycleTracker, Trackers } from "interfaces";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { onPBV3change, selectPoisBountyV3State } from "redux/slices";
import { CrownIcon } from "utils/svgIcons";
import { getTimeLeft } from "utils/time";
import {
	Bar,
	Button,
	EmptyProgressBar,
	FillPercentage,
	FillText,
	//RewardsCountDot,
	Sticky,
	Text
} from "./styles";

interface PoisBountyStickyTagProps {}

const PoisBountyStickyTag = ({}: PoisBountyStickyTagProps) => {
	const links = useLinks();
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const isLarge = useMediaQuery("(min-width: 721px)");
	const { userTracker, nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { getImage } = useImagePath("cdn");
	const { eventActive, isTagActive, tracker, cycleTrackers, trackers } =
		useAppSelector(selectPoisBountyV3State);
	const { loyaltyPoints, rewardClaimStatuses, eventId, cycleIndex, endTime } =
		tracker || {};
	//const [unclaimedRewardsCount, setUnclaimedRewardsCount] = useState<number>(0);
	const [previousData, setPreviousData] = useState<
		Trackers | PBV3CycleTracker
	>();
	const { pathname } = location;
	const isClub = useMemo(() => trackers?.eventType === "club", [trackers]);

	const timeTotal = useMemo(() => {
		return getTimeLeft(tracker?.startTime, tracker?.endTime, "seconds") || 0;
	}, [tracker?.eventId]);

	useEffect(() => {
		if (
			!!userTracker &&
			pathname !== links.home.path &&
			pathname !== links.pois_bounty.path &&
			eventActive
		) {
			if (previousData?.loyaltyPoints === loyaltyPoints) {
				return;
			}
			setPreviousData(cycleTrackers?.[0]);
			/* let count = 0;
			cycleTrackers?.map((t) => {
				count += t.rewardClaimStatuses.filter(
					(rcs) =>
						rcs.isClaimed === false &&
						rcs.reward.loyaltyPoints <= t.loyaltyPoints
				).length;
			});
			setUnclaimedRewardsCount(count); */
			dispatch(onPBV3change({ isTagActive: true }));

			const timeLeft = getTimeLeft(nowTime, endTime, "seconds");
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "spawn",
				event_type: "pois_bounty_v3",
				action: "spawn",
				source: "pbv3_progress_bar_pop_up",
				value_int2: loyaltyPoints,
				node_type: rewardClaimStatuses
					?.slice(-1)[0]
					?.reward?.loyaltyPoints?.toString(),
				node_type2: cycleIndex?.toString(),
				loopcount: cycleIndex,
				//value_int: count,
				type: trackers?.eventType === "user" ? "personal" : trackers?.eventType,
				time_left: timeLeft,
				time_total: timeTotal,
				event_id: eventId
			});
		} else {
			dispatch(onPBV3change({ isTagActive: false }));
		}
	}, [cycleTrackers, eventActive, pathname, userTracker]);

	return isTagActive && pathname !== links.pois_bounty.path ? (
		<Sticky
			imageUrl={
				isClub
					? isLarge
						? getImage(poisBountyAssets.v3.stickyTag.backgroundLandscape)
						: getImage(poisBountyAssets.v3.stickyTag.background)
					: isLarge
					? getImage(poisBountyAssets.v2.stickyTag.backgroundLandscape)
					: getImage(poisBountyAssets.v2.stickyTag.background)
			}
		>
			<Button
				className="button"
				onClick={() => {
					dispatch(onPBV3change({ isTagActive: false }));
					const timeLeft = getTimeLeft(nowTime, endTime, "seconds");
					reportPlaygamiEvent("tp.web_frontend", {
						event_name: "close",
						event_type: "pois_bounty_v3",
						action: "close",
						source: "pbv3_progress_bar_sticky_tag",
						value_int2: loyaltyPoints,
						node_type: rewardClaimStatuses
							?.slice(-1)[0]
							?.reward?.loyaltyPoints?.toString(),
						node_type2: cycleIndex?.toString(),
						loopcount: cycleIndex,
						//value_int: unclaimedRewardsCount,
						type:
							trackers?.eventType === "user" ? "personal" : trackers?.eventType,
						time_left: timeLeft,
						time_total: timeTotal,
						event_id: eventId
					});
				}}
			>
				<HighlightOffOutlined
					sx={{
						strokeWidth: 0.005,
						width: 30,
						height: 30,
						backgroundColor: "rgba(0,0,0, .3)",
						borderRadius: "100%",
						color: "#fff",
						"&:hover": {
							backgroundColor: "rgba(0,0,0, .6)"
						}
					}}
					fontSize="large"
				/>
			</Button>
			<div
				onClick={() => {
					navigate(links.pois_bounty.path);
					const timeLeft = getTimeLeft(nowTime, endTime, "seconds");
					reportPlaygamiEvent("tp.web_frontend", {
						event_name: "click",
						event_type: "pois_bounty_v3",
						action: "click",
						source: "pbv3_progress_bar_sticky_tag",
						value_int2: loyaltyPoints,
						node_type: rewardClaimStatuses
							?.slice(-1)[0]
							?.reward?.loyaltyPoints?.toString(),
						node_type2: cycleIndex?.toString(),
						loopcount: cycleIndex,
						//value_int: unclaimedRewardsCount,
						type:
							trackers?.eventType === "user" ? "personal" : trackers?.eventType,
						time_left: timeLeft,
						time_total: timeTotal,
						event_id: eventId
					});
				}}
			>
				<Text className="text">{isClub ? "Club " : ""}Poi’s Bounty</Text>
				{/* 📊 Reward Progress Bar */}
				<EmptyProgressBar>
					{/* {unclaimedRewardsCount > 0 && <RewardsCountDot />} */}
					<Bar className="reward-bar">
						<FillPercentage
							style={{
								width: getMiniProgressBarWidth(
									loyaltyPoints || 0,
									rewardClaimStatuses?.slice(-1)?.[0]?.reward?.loyaltyPoints ||
										0
								)
							}}
						></FillPercentage>
						<FillText>
							<CrownIcon />
							<p>
								{`${loyaltyPoints} / ${
									rewardClaimStatuses?.slice(-1)?.[0]?.reward?.loyaltyPoints
								}`}
							</p>
						</FillText>
					</Bar>
				</EmptyProgressBar>
			</div>
		</Sticky>
	) : null;
};

export default PoisBountyStickyTag;
